import { Element, Node } from "@siteimprove/alfa-dom";
import { Context } from "../../../context.js";
import { Specificity } from "../../../specificity.js";
import { WithSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/css-scoping-1/#selectordef-host-context}
 *
 * @privateRemarks
 * In CSS lingo, `:host-context` only accepts a compound selector, but simple
 * selectors are also compounds. Alfa does make a type difference between
 * a Simple selector and a compound selector with only a single Simple
 * selector. Hence, this also accepts Simple selector. This also accepts
 * pseudo-elements, which seems to not be really allowed by the specification.
 *
 * @public
 */
export class HostContext extends WithSelector {
    static of(selector) {
        return new HostContext(selector);
    }
    constructor(selector) {
        super("host-context", selector, Specificity.sum(selector.specificity, Specificity.of(0, 1, 0)));
    }
    *[Symbol.iterator]() {
        yield this;
    }
    /**
     * @remarks
     * `:host-context` never matches anything in its own tree.
     */
    matches(element, context) {
        return false;
    }
    matchHost(
    /**
     * Checks whether a shadow host matches.
     *
     * @remarks
     * This must be called with `element` being the shadow host of
     * the Document that defines the selector.
     */
    element, context = Context.empty()) {
        return element
            .inclusiveAncestors(Node.Traversal.of(Node.Traversal.composed))
            .filter(Element.isElement)
            .some((ancestor) => this._selector.matches(ancestor, context));
    }
    equals(value) {
        return (value instanceof HostContext && value._selector.equals(this._selector));
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
}
(function (HostContext) {
    function isHostContext(value) {
        return value instanceof HostContext;
    }
    HostContext.isHostContext = isHostContext;
    HostContext.parse = (parseSelector) => WithSelector.parseWithSelector("host-context", parseSelector, HostContext.of);
})(HostContext || (HostContext = {}));
//# sourceMappingURL=host-context.js.map